class FieldNameInputModel {
    fieldId: number;
    metric: boolean;
    mapField: boolean;
    all: boolean;
    metricName: string;
    autoGrouping: AutoGroupingEnum;
    color: string;
    tableName: string;
    fieldName: string;
    nodeName: string;
    order: number;
    groupingType: GroupingTypeEnum;
    isReportMetric: boolean;
    originalName: string;
    displayName: string;
    format: FieldFormatEnum;
    decimalPlaces: number | null;
    foreColor: string;
    backgroundColor: string;
    thresholdValue: number | null;
    thresholdColor: string;
    formattingRuleId: number;
    formattingRuleName: string;
    type: DataTypeEnum;
    comparisonType: ComparisonMetricType;
    comparisonFilterId: string;
    comparisonMetricId: string;
    metricId: number;
    queryName: string;
    visualizationMode: string; //VisualizationModeEnum;
    barChartText: string; //BarChartTextEnum;
    barChartTextPosition: string; //BarChartTextPositionEnum;
    colorBar: string;
    negativeColorBar: string;
    columnWidth: number;
    fields: Array<FieldNameInputModel>;
    visibility: VisibilityEnum;
    accountingStyle: boolean;

    get internalDisplayName() {
        return this.displayName;
    }

    constructor(data: any = null) {
        if (data) {
            //this.copyProperties(data, this);
            this.fieldId = data.fieldId;
            this.metric = data.metric;
            this.mapField = data.mapField;
            this.all = data.all;
            this.metricName = data.metricName;
            this.autoGrouping = data.autoGrouping;
            this.color = data.color;
            this.tableName = data.tableName;
            this.fieldName = data.fieldName;
            this.originalName = data.originalName;
            this.nodeName = data.nodeName;
            this.order = data.order;
            this.groupingType = data.groupingType;
            this.isReportMetric = data.isReportMetric;
            this.displayName = data.displayName;
            this.format = data.format;
            this.decimalPlaces = data.decimalPlaces;
            this.foreColor = data.foreColor;
            this.backgroundColor = data.backgroundColor;
            this.thresholdValue = data.thresholdValue;
            this.thresholdColor = data.thresholdColor;
            this.formattingRuleId = data.formattingRuleId;
            this.formattingRuleName = data.formattingRuleName;
            this.type = data.type;
            this.comparisonType = data.comparisonType;
            this.comparisonFilterId = data.comparisonFilterId;
            this.comparisonMetricId = data.comparisonMetricId;
            this.metricId = data.metricId;
            this.queryName = data.queryName;
            this.visualizationMode = data.visualizationMode;
            this.barChartText = data.barChartText;
            this.barChartTextPosition = data.barChartTextPosition;
            this.colorBar = data.colorBar;
            this.negativeColorBar = data.negativeColorBar;
            this.columnWidth = data.columnWidth;
            this.visibility = data.visibility;
            this.accountingStyle = data.accountingStyle;
            this.fields = createInstances(FieldNameInputModel, data.fields);
        }
    }

    //duplicate(name: string) {
    //    let copy = this.clone();
    //    copy.nodeName = name;
    //    copy.displayName = name;
    //    return copy;
    //}

    //clone(): FieldNameInputModel {
    //    let fromObject = this;
    //    let toObject: FieldNameInputModel = new FieldNameInputModel();
    //    this.copyProperties(fromObject, toObject);
    //    return toObject;
    //}

    //copyProperties(fromObject, toObject) {
    //    for (let property in fromObject) {
    //        if (fromObject[property] !== undefined) {
    //            let fromValue = fromObject[property];
    //            if (Array.isArray(fromValue)) {
    //                toObject[property] = [];
    //                for (var i = 0; i < fromValue.length; i++) {
    //                    let itemArray = fromValue[i];
    //                    let newItemArray = {};
    //                    this.copyProperties(itemArray, newItemArray);
    //                    toObject[property].push(newItemArray);
    //                }
    //            }
    //            else if (typeof fromValue === "object") {
    //                this.copyProperties(fromValue, toObject[property] || {});
    //            }
    //            else {
    //                toObject[property] = fromValue;
    //            }
    //        }
    //    }
    //}

    createMetricOrReportField(isOriginalTemplate: boolean = false): MetricField | ReportField {
        let metricOrReportField: MetricField | ReportField;

        let data = {
            id: null,
            field: this.fieldId,
            autoGrouping: this.autoGrouping,
            groupingType: this.groupingType,
            isReportMetric: false,
            visible: true,
            color: null,
            titleAlign: TextAlignEnum.Auto,
            valuesAlign: TextAlignEnum.Auto,
            orderIndex: null,
            order: 0,
            groupId: null,
            width: null,
            customDisplayName: null,
            displayName: null,
        } as any;
        if (this.metric) {
            data.field = null;

            data.numberFormat = this.format;
            data.decimalPlaces = this.decimalPlaces;
            data.accountingStyle = this.accountingStyle;
            data.backgroundColor = this.backgroundColor;
            data.foreColor = this.foreColor;
            data.thresholdValue = this.thresholdValue;
            data.thresholdColor = this.thresholdColor;
            data.isChecked = true;
            data.useFormattingRuleFromMetric = true;
            data.formattingRule = this.formattingRuleId;
            data.visualizationModeDefinition = {
                visualizationMode: this.visualizationMode,
                barChartText: this.barChartText,
                barChartTextPosition: this.barChartTextPosition,
                color: this.colorBar,
                negativeColor: this.negativeColorBar                
            };
            data.showSubtotalValue = true;
            data.showTotalValue = true;
            data.calculateTotals = null;
            data.metricFormat = {
                format: this.format,
                decimalPlaces: this.decimalPlaces,
                accountingStyle: this.accountingStyle,
            };

            //let metric = MappingService.getMetric(item.metricId);
            data.metricContainer = {
                metric: this.metricId,
                isExpression: false,
                comparisonType: ComparisonTypeEnum.None,
                comparisonFilterId: null,
                functionType: FunctionTypeEnum.Normal,
            }
            metricOrReportField = new MetricField(data, isOriginalTemplate);
        }
        else {
            metricOrReportField = new ReportField(data, isOriginalTemplate);
        }

        return metricOrReportField;
    }
}